import SummarizeSpokenTextData from "../../../../doc/listening/summarize-spoken-text/SummarizeSpokenTextData.js";
import SummarizeSpokenTextList from "../../../../doc/components/SummarizeSpokenTextList.js";
import * as React from 'react';
export default {
  SummarizeSpokenTextData,
  SummarizeSpokenTextList,
  React
};